import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';

export const VerticalBar = styled.div`
  width: 2px;
  background: ${colors.neutralLight10};
  height: 24px;
`;
